import React from "react";
import { Flex, Text } from "rebass/styled-components";

import { Button } from "../Button";
import { useRiotLink } from "../../Hooks/useRiotLink";
import { useUser } from "../../Hooks/useUser";

interface IRiotReplayAccessNoticeProps {
  force?: boolean;
  compact?: boolean;
  onReconnect?: () => void;
}

export const RiotReplayAccessNotice: React.FC<IRiotReplayAccessNoticeProps> = ({
  force = false,
  compact = false,
  onReconnect,
}) => {
  const { allstarUser } = useUser();
  const { link } = useRiotLink();
  const riot = allstarUser?.user?.riot;

  if (!force && !(riot?.active && riot?.hasReplayAccess === false)) {
    return null;
  }

  return (
    <Flex
      role="status"
      alignItems="center"
      justifyContent="space-between"
      style={{ gap: compact ? 8 : 16 }}
      py={compact ? 1 : 3}
    >
      <Text fontSize={compact ? 1 : 2}>
        Reconnect your Riot account so Allstar can fetch your replays
      </Text>
      <Button
        size="small"
        flex={true}
        maxWidth={2}
        flexShrink={0}
        classification="secondary"
        onClick={() => {
          link("CLIP_SURFACE", { reconnect: true });
          onReconnect?.();
        }}
      >
        Reconnect
      </Button>
    </Flex>
  );
};
